var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcBadgeStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.666 5.333V5.5c0 1.38-.995 2.5-2.222 2.5-1.227 0-2.222-1.12-2.222-2.5C10.222 6.88 9.227 8 8 8 6.772 8 5.777 6.88 5.777 5.5c0 1.38-.994 2.5-2.222 2.5-1.227 0-2.222-1.12-2.222-2.5v-.167a4 4 0 014-4h5.333a4 4 0 014 4zM12.444 9c-.891 0-1.66-.375-2.222-.963a3.043 3.043 0 01-4.445 0A3.043 3.043 0 012 8.57V12a2.667 2.667 0 002.666 2.666h6.667A2.667 2.667 0 0014 12V8.57A3 3 0 0112.444 9zm-2.009 2.754a.5.5 0 01-.19.681c-.81.457-1.508.73-2.243.731-.737.002-1.436-.27-2.25-.732a.5.5 0 01.495-.869c.757.431 1.274.602 1.753.601.48 0 .996-.174 1.754-.602a.5.5 0 01.681.19z",
    clipRule: "evenodd"
  })));
}

export default SvgIcBadgeStore;